<template>
<div class="modal user-management-confirmation-modal"
     :class="{ 'is-active': isShown }"
>
    <div class="modal-background" @click="hideModal"></div>

    <div class="modal-card">

        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon has-text-white">
                    <i class="fas fa-exclamation-triangle"></i>
                </span>
                {{ trans.confirmation_modal_title }}
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="hideModal"
                :disabled="isLoading"
            ></button>
        </header>

        <section class="modal-card-body">
            <div class="content">
                {{ trans.confirmation_modal_text }}
            </div>
        </section>

        <footer class="modal-card-foot">
            <button
                class="button is-info"
                :class="{ 'is-loading': isLoading }"
                :disabled="isLoading"
                @click="confirm"
            >
                {{ trans.continue_button}}
            </button>
            <button
                class="button"
                @click="hideModal"
                :disabled="isLoading"
            >
                {{ trans.return_button }}
            </button>
        </footer>

    </div>
</div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "UserManagementConfirmationModal",
        props: {
            trans: Object,
        },
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            ...mapActions('userManagement', {
                hideModal: 'hideConfirmationModal',
            }),
            confirm() {
               this.$emit('confirmation-event');
               this.isLoading = true;
            },
        },
        computed: {
            ...mapState('userManagement', {
                isShown: 'isConfirmationModalShown',
            })
        },
    }
</script>

<style lang="scss" scoped>
.user-management-confirmation-modal {
    .modal-card-head {
        border-radius: 0px;
        background-color: #FC6859;
        padding: 1rem;
        font-size: 1.2rem;

        .modal-card-title {
            color: white;
            border-radius: 0px;
        }
    }
}
</style>
